"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterAssetRequestToJSON = exports.RegisterAssetRequestFromJSONTyped = exports.RegisterAssetRequestFromJSON = exports.instanceOfRegisterAssetRequest = void 0;
var runtime_1 = require("../runtime");
var AssetSubtype_1 = require("./AssetSubtype");
var AssetType_1 = require("./AssetType");
/**
 * Check if a given object implements the RegisterAssetRequest interface.
 */
function instanceOfRegisterAssetRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "assetType" in value;
    return isInstance;
}
exports.instanceOfRegisterAssetRequest = instanceOfRegisterAssetRequest;
function RegisterAssetRequestFromJSON(json) {
    return RegisterAssetRequestFromJSONTyped(json, false);
}
exports.RegisterAssetRequestFromJSON = RegisterAssetRequestFromJSON;
function RegisterAssetRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'assetType': (0, AssetType_1.AssetTypeFromJSON)(json['asset_type']),
        'assetSubtype': !(0, runtime_1.exists)(json, 'asset_subtype') ? undefined : (0, AssetSubtype_1.AssetSubtypeFromJSON)(json['asset_subtype']),
    };
}
exports.RegisterAssetRequestFromJSONTyped = RegisterAssetRequestFromJSONTyped;
function RegisterAssetRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'asset_type': (0, AssetType_1.AssetTypeToJSON)(value.assetType),
        'asset_subtype': (0, AssetSubtype_1.AssetSubtypeToJSON)(value.assetSubtype),
    };
}
exports.RegisterAssetRequestToJSON = RegisterAssetRequestToJSON;
